<template>
    <footer class="content-grid">
        <div class="footer-flex">
            <div class="footer-navigation">
                <div>
                    <ul>
                        <li><strong>Product</strong></li>
                        <li><NuxtLink to="/ai">Generate ads with&nbsp;AI</NuxtLink></li>
                        <li><NuxtLink to="/figma_plugin">Animate Figma designs</NuxtLink></li>
                        <li>
                            <a
                                href="https://www.figma.com/community/plugin/1386253956477384244/foldwrap-banner-generator"
                                class="external-link"
                                target="_blank"
                                rel="noreferrer noopener"
                                >Figma plugin</a
                            >
                        </li>
                        <li><NuxtLink to="/contact">Contact</NuxtLink></li>
                        <li><NuxtLink to="/changelog">Changelog</NuxtLink></li>
                        <li><NuxtLink to="/legal">Legal & Privacy</NuxtLink></li>
                        <li><a href="/help/">Help</a></li>
                        <li><NuxtLink to="/page/about">About</NuxtLink></li>
                    </ul>
                </div>

                <div>
                    <ul>
                        <li><strong>Features</strong></li>

                        <li><NuxtLink to="/features/resize-banners-with-ai">Resizes with&nbsp;AI</NuxtLink></li>
                        <li><NuxtLink to="/features/automatic-animation">Automatic animation</NuxtLink></li>
                        <li><NuxtLink to="/features/ai-powered-edits">AI-powered editing</NuxtLink></li>
                        <li><NuxtLink to="/features/html5-banner-ads">Native HTML5 ads</NuxtLink></li>
                        <li><NuxtLink to="/features/video-export">Video export</NuxtLink></li>
                        <li><NuxtLink to="/features/gif-export">GIF export</NuxtLink></li>
                        <li><NuxtLink to="/features/ai-powered-translation">AI-powered translation</NuxtLink></li>
                        <li><NuxtLink to="/features/side-by-side-review">Side-by-side review</NuxtLink></li>
                        <li><NuxtLink to="/features/scale-with-data">Scale ads with data</NuxtLink></li>
                    </ul>
                </div>

                <div>
                    <ul class="!mb-8">
                        <li><strong>Examples</strong></li>
                        <li><NuxtLink to="/editor/668bba202f686111aea3f57e">Animated banner example</NuxtLink></li>
                        <li><NuxtLink to="/editor/66741dca5b5fa70ddeddb6b5">Videobanner example</NuxtLink></li>
                    </ul>

                    <ul>
                        <li><strong>Blog posts</strong></li>
                        <li><NuxtLink to="/blog/how-to-use-figma-plugin">How to use our Figma plugin</NuxtLink></li>
                        <li><NuxtLink to="/blog/scale-banner-ads">How to scale up banner ads</NuxtLink></li>
                        <li>
                            <NuxtLink to="/blog/creative-automation-in-advertising">Creative automation in advertising</NuxtLink>
                        </li>
                        <li class="flex gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16" class="mt-1">
                                <g fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0"
                                    />
                                    <path
                                        d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"
                                    />
                                    <path
                                        d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
                                    />
                                </g>
                            </svg>
                            <NuxtLink to="/blog">Ads Automation Blog</NuxtLink>
                        </li>
                    </ul>
                </div>

                <div>
                    <ul class="!mb-8">
                        <li><strong>Solutions</strong></li>
                        <li><NuxtLink to="/solutions/digital-agencies">Digital Agencies</NuxtLink></li>
                        <li><NuxtLink to="/solutions/in-house">In-house Teams</NuxtLink></li>
                        <li><NuxtLink to="/solutions/freelancers">Freelance Designers</NuxtLink></li>
                    </ul>

                    <ul class="!mb-8">
                        <li><strong>Alternatives-to</strong></li>
                        <li><NuxtLink to="/alternatives-to/adobe-animate">Adobe Animate</NuxtLink></li>
                        <li><NuxtLink to="/alternatives-to/google-web-designer">Google Web Designer</NuxtLink></li>
                    </ul>

                    <ul>
                        <li><strong>Free tools</strong></li>
                        <li><NuxtLink to="/tools/markdown-slides">Markdown to slides</NuxtLink></li>
                    </ul>
                </div>
            </div>
        </div>

        <div>
            <div><a class="hello-mail" href="mailto:hello@foldwrap.com">hello@foldwrap.com</a></div>
            <!-- <div>
      /by <NuxtLink to="/page/about">Alex</NuxtLink> {{ new Date().getFullYear() }}
    </div> -->
            <div>&copy Foldwrap {{ new Date().getFullYear() }}</div>
        </div>
    </footer>
</template>
